/**
 * The legal apps view's words the Integrations page shows BEFORE the view has loaded (legal apps delivery 2,
 * 2026-09-29): the chip, and the line while it loads or if it cannot. They ride the page's own download; every
 * other word of the view is legalAppsCopy.ts, in the `legal-apps` chunk, which spreads this table so the two
 * can never disagree. D9 state chrome, English like the page.
 */
export const LEGAL_APPS_CHROME_COPY = {
  /** The chip beside the page's other categories; also the category's value in the page's state. */
  chip: 'legal apps',
  loading: 'loading the legal apps…',
  unavailable: "the legal apps couldn't load — try again in a moment.",
};

/** The address that opens the page on the legal apps view: /integrations?category=legal. */
export const LEGAL_APPS_CATEGORY_PARAM = 'legal';
